import React, { useState, useEffect, useRef, useMemo } from 'react';

interface TruncateTextProps {
    text: string;
    lineHeight: number; // Line height in pixels
    className?: string;
}

const TruncateText: React.FC<TruncateTextProps> = ({ text, lineHeight, className }) => {
    const textRef = useRef<HTMLParagraphElement>(null);
    const [containerWidth, setContainerWidth] = useState<number>(0);

    useEffect(() => {
        if (textRef.current) {
            setContainerWidth(textRef.current.offsetWidth);
        }
    }, [textRef]);

    const truncatedText = useMemo(() => {
        return `${`${text}`.substring(0, 69)}${`${text}`.length > 69 ? '...' : ''}`
    }, [text, containerWidth]);

    return (
        <p ref={textRef}
            title={text}
            className={className}
            style={{ lineHeight: `${lineHeight}px` }}>
            {truncatedText}
        </p>
    );
};

export default TruncateText;
